import { ISecurityReference } from 'api/overrides.types'
import { getSecurityReferences } from 'api/security'
import axios from 'axios'
import { AppState } from 'store'
import {
  createAsyncReducer,
  createAsyncSelectors,
  getRockefellerApiOptions
} from 'store/shared'
import { call, cancelled, put, takeLatest } from 'typed-redux-saga'
import { createAsyncAction } from 'typesafe-actions'

export const SecurityReferenceFetchActions = createAsyncAction(
  '@modules/@security/@overrides/@references/REQUEST',
  '@modules/@security/@overrides/@references/SUCCESS',
  '@modules/@security/@overrides/@references/FAILURE'
)<string, ISecurityReference, Error>()

export const securityReferenceFetchReducer = createAsyncReducer(
  SecurityReferenceFetchActions
)

const rootSelector = (state: AppState) =>
  state.modules.overrides.securityReferenceFetch

export const {
  getError: getSecurityReferenceFetchError,
  getIsLoading: getSecurityReferenceFetchLoading,
  getResult: getSecurityReferenceFetchResult
} = createAsyncSelectors(rootSelector)

const onRequest = function* (
  action: ReturnType<typeof SecurityReferenceFetchActions.request>
) {
  // eslint-disable-next-line import/no-named-as-default-member
  const source = axios.CancelToken.source()
  const apiOptions = yield* call(getRockefellerApiOptions, source.token)

  try {
    const result = yield* call(
      getSecurityReferences,
      apiOptions,
      action.payload
    )
    yield put(SecurityReferenceFetchActions.success(result))
  } catch (e: any) {
    yield put(SecurityReferenceFetchActions.failure(e))
  } finally {
    if (yield* cancelled()) {
      source.cancel()
    }
  }
}

export const securityReferenceFetchSagas = [
  () => takeLatest(SecurityReferenceFetchActions.request, onRequest)
]
